// extracted by mini-css-extract-plugin
module.exports = {"container":"_2y64u","title":"_2ggGD"};